// extracted by mini-css-extract-plugin
module.exports = {"section":"HotBid_section__3bTmV","wrapper":"HotBid_wrapper__8UEWu","title":"HotBid_title__2pVAf","inner":"HotBid_inner__3P1d7","card":"HotBid_card__3Jk9n"};